import { EntityActionTypeSelectOptionValue } from '../../Entity'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../TaskForm'

export const QA_NAME_EDIT_DEADLINE_MODAL = 'editDeadline'

export const TASK_EDIT_DEADLINE_FIELDS_INITIAL_VALUES = {
  [TASK_FORM_DEADLINE_FIELD_NAME]: null,
}

export const TASK_EDIT_DEADLINE_FORM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]
